const BASE_PATH = '/';

export const privatePaths = {
  ADMIN_USERS: `${BASE_PATH}admin-users`,
  PROFILE: `${BASE_PATH}profile`,
  COUNTRIES: `${BASE_PATH}countries`,
  REGIONS: `${BASE_PATH}regions`,
  END_USERS: `${BASE_PATH}end-users`,
  SOURCES: `${BASE_PATH}sources`,
  PLANS: `${BASE_PATH}plans`,
  TENANTS: {
    home: `${BASE_PATH}workspaces`,
    detail: `${BASE_PATH}workspaces/:id`,
  },
};
